import { useState } from "react";

export function oggiDmy() {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

/**
 * Input per la "Data di stampa" usata come placeholder «Data.Stampa» nei modelli .docx.
 * Mostra anche un input HTML date come scorciatoia (in basso) e l'utente può digitare manualmente
 * in formato gg/mm/aaaa nel campo principale.
 */
export function DataStampaField({ value, onChange, testid = "data-stampa-input" }) {
  const [touched, setTouched] = useState(false);
  const v = value || "";
  // converte gg/mm/aaaa → aaaa-mm-gg per <input type=date>
  const isoFromDmy = (s) => {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || "");
    return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
  };
  // converte aaaa-mm-gg → gg/mm/aaaa
  const dmyFromIso = (s) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || "");
    return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
  };
  const valid = !v || /^\d{2}\/\d{2}\/\d{4}$/.test(v);
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: "block", fontSize: 11, color: "#666", marginBottom: 4 }}>
        📅 DATA DI STAMPA <span style={{ color: "#999", fontWeight: 400 }}>(usata nel placeholder «Data.Stampa», default = oggi)</span>
      </label>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <input type="text" placeholder="gg/mm/aaaa" value={v}
          onBlur={() => setTouched(true)}
          onChange={e => onChange(e.target.value)}
          data-testid={testid}
          style={{
            flex: 1, padding: "6px 10px",
            border: `1px solid ${touched && !valid ? "#c62828" : "#ccc"}`,
            fontSize: 12,
          }} />
        <input type="date" value={isoFromDmy(v)}
          onChange={e => onChange(dmyFromIso(e.target.value))}
          data-testid={`${testid}-picker`}
          title="Apri il picker"
          style={{ width: 140, padding: "5px 6px", border: "1px solid #ccc", fontSize: 12 }} />
      </div>
      {touched && !valid && (
        <div style={{ fontSize: 11, color: "#c62828", marginTop: 4 }}>Formato richiesto: gg/mm/aaaa</div>
      )}
    </div>
  );
}
